import { Link } from 'react-router-dom'

export default function PatreonPanel() {
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="artifact-frame p-8 sm:p-12 text-center">
          {/* Icon */}
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-archive-gold/10 flex items-center justify-center border border-archive-gold/30">
            <svg className="w-8 h-8 text-archive-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
          </div>

          {/* Heading */}
          <h2 className="font-display text-2xl sm:text-3xl text-archive-cream">
            Keep the network free
          </h2>

          {/* Description */}
          <p className="mt-4 text-archive-muted max-w-xl mx-auto">
            The Archive Network is a solo-run, independent project — free and open, no ads,
            no paywalls. Donations don't unlock perks; they simply keep everything free for
            everyone and fund more research, production, and new archives.
          </p>

          {/* CTA */}
          <Link to="/support" className="inline-flex items-center gap-2 mt-8 btn-primary">
            Ways to support
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  )
}
